import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoices"
export default class extends Controller {
  static targets = ["form", 'uploadButton']

  connect() {
    console.log("Invoices controller connected")
    const input = document.querySelector('input[name="query_invoices"]');
    const form = this.formTarget
    // I want to initialize the date ranger picker with the current week range
    const today = moment();
    const startOfWeek = today.clone().startOf('week');
    const endOfWeek = today.clone().endOf('week');
    // Input is saying invalid date - invalid date
    //
    $('input[name="query_invoices"]').daterangepicker({
      opens: 'left',
      startDate: startOfWeek,
      endDate: endOfWeek
    }, 
      function(start, end, label) {
      input.value = start.format('YYYY-MM-DD') + ' - ' + end.format('YYYY-MM-DD');
      form.requestSubmit();
    });
  }

  submitUpload(event) {
    if (this.uploadButtonTarget.form.checkValidity()) {
      this.uploadButtonTarget.value = "Uploading...";
      this.uploadButtonTarget.classList.add("bg-gray-400")
    }
  }

  closeModalUploadInvoices() {
   const dialog = document.getElementById("upload-invoices");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

   closeModalFind() {
    const dialog = document.getElementById("find-invoices");
    if (dialog) {
      dialog.close();
    } else {
      console.error("Dialog with id 'turbo-create-category' not found.");
    }
  }

}
